module.exports = __webpack_public_path__ + "img/SIS-HAZUL.e134f479.png";